import { render, staticRenderFns } from "./login-domestic.vue?vue&type=template&id=6b5afa40"
import script from "./login-domestic.vue?vue&type=script&lang=js"
export * from "./login-domestic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports